import { CONTACT, SOCIALS, STUDIO } from "@/config";
import { Instagram, Mail, Phone } from "lucide-react";

const socialIcons = {
  instagram: Instagram,
};

const navLinks = [
  { href: "#specs", label: "The Space" },
  { href: "#amenities", label: "Amenities" },
  { href: "#backdrops", label: "Backdrops" },
  { href: "#inventory", label: "Props" },
  { href: "#plans", label: "Packages" },
  { href: "#promo", label: "Voucher" },
  { href: "#terms", label: "Terms" },
  { href: "#contact", label: "Book" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-footer-bg text-muted-g border-t border-deep-surface py-12 text-xs">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="text-center md:text-left">
          <div className="flex items-center justify-center md:justify-start gap-3 mb-2">
            <img src={STUDIO.logo} alt="Room 9 logo" className="w-10 h-10 object-contain invert" />
            <span className="font-extrabold text-white text-base leading-none">{STUDIO.fullName}</span>
          </div>
          <span data-testid="footer-description" className="text-[#CFC9BB]">A thoughtfully curated rental studio in Ahmedabad — photography, video shoots,
            content creation and workshops.</span>
          <div className="mt-3 flex flex-col sm:flex-row items-center gap-3 text-[11px] text-[#CFC9BB]">
            <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="inline-flex items-center gap-1.5 hover:text-white transition-colors">
              <Mail size={12} /> {CONTACT.email}
            </a>
            <a href={CONTACT.phoneHref} data-testid="footer-phone" className="inline-flex items-center gap-1.5 hover:text-white transition-colors">
              <Phone size={12} /> {CONTACT.phoneDisplay}
            </a>
          </div>
        </div>
        <nav className="flex flex-wrap items-center justify-center gap-6 font-bold uppercase text-[11px] text-[#CFC9BB]">
          {navLinks.map((l) => (
            <a key={l.href} href={l.href} data-testid={`footer-nav-${l.label.toLowerCase()}`} className="hover:text-white transition-colors">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          {SOCIALS.map((s) => {
            const Icon = socialIcons[s.id];
            return (
              <a
                key={s.id}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                data-testid={`footer-social-${s.id}`}
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-deep-surface border border-deep-border text-white hover:bg-forest transition-colors"
              >
                <Icon size={14} />
              </a>
            );
          })}
        </div>
      </div>
      <div className="mt-8 pt-8 border-t border-deep flex flex-col sm:flex-row items-center justify-end gap-4">
        <a
          href="/room9-brochure.pdf"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-brochure-link"
          className="hover:text-white transition-colors"
        >
          Download Brochure (PDF)
        </a>
        <p>{STUDIO.fullName}</p>
      </div>
    </div>
  </footer>
);
